import React, { forwardRef, useRef, useImperativeHandle } from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { useApolloClient } from '@apollo/client'
import { func } from 'prop-types'

import { useAuthenticationDispatch } from '../../../../../contexts/AuthenticationContext'
import AuthenticationService from '../../../../../services/ApiService/AuthenticationService'
import { userMenuMessages } from '../../../../../translations'
import { Button } from '../../../../Button'

const StyledButton = styled(Button)`
  display: flex;
  width: 100%;
  font-size: 0.8125rem !important;
  font-weight: normal !important;
  padding: 0.625rem 1.0625rem;
  color: ${({ theme }) => theme.textColor} !important;
`

export const SignOut = forwardRef(({ onSignOutClick }, ref) => {
  const localRef = useRef()
  const authenticationDispatch = useAuthenticationDispatch()
  const client = useApolloClient()
  useImperativeHandle(ref, () => localRef.current)

  const handleSignout = () => {
    const service = new AuthenticationService()
    service
      .signOutUser()
      .then((result) => {
        authenticationDispatch({
          type: useAuthenticationDispatch.ACTION_TYPES.CLEAR_USER,
          user: null,
        })
        client.resetStore()
      })
      .catch((err) => {
        throw err
      })
  }
  const { formatMessage } = useIntl()

  return (
    <StyledButton onClick={onSignOutClick || handleSignout} ref={localRef}>
      {formatMessage(userMenuMessages.signOut)}
    </StyledButton>
  )
})

SignOut.propTypes = {
  onSignOutClick: func,
}
